module.exports = __webpack_public_path__ + "static/media/covid.a496bf6e.png";